import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Shadow } from "../../../../utils/BreakpointHelpers";
import { roundNumber } from "../../../../utils/NumberHelpers";

export const CardContainer = styled.div`
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}

    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    color: ${({ theme }) => theme.colors.blue.toString()};
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.grey.toString()};
    padding-top: 10px;
    padding-bottom: 10px;
    ${({ theme }) => theme.breakpoints.from.small.css`
       ${Shadow};

       border-color: none;
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
       flex-direction: row;
       padding: 20px;
    `}
`;

const Left = styled.p`
    font-size: 1.5rem;
    align-self: flex-start;
    font-weight: 600;
    ${({ theme }) => theme.breakpoints.from.medium.css`
       width: 20%;
    `}
`;

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

const Middle = styled.p`
    align-self: center;
    max-width: 60%;
    font-size: 1rem;
`;

const Right = styled.p`
    align-self: flex-start;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: right;
`;

const FirstRow = css`
    font-weight: 600;
`;

const Card = ({ left, middle, right, container = true }) => {
    const content = (
        <>
            <Left>{left}</Left>
            <Wrapper>
                <Middle>
                    {Array.isArray(middle)
                        ? middle.map((item, index) => {
                              return (
                                  <div key={index}>
                                      <span css={index === 0 ? FirstRow : ""}>
                                          {item.text}{" "}
                                          {item.allergenesAndAdditions}
                                      </span>
                                  </div>
                              );
                          })
                        : middle}
                </Middle>
                <Right>{roundNumber(right)} €</Right>
            </Wrapper>
        </>
    );

    if (container) {
        return <CardContainer>{content}</CardContainer>;
    }

    return content;
};

export default Card;
